const normalizeAgencyName = (
  agencyName: string | null | undefined
): string | null => {
  const name = agencyName?.trim();
  return name !== undefined && name !== '' ? name : null;
};

/**
 * Edge has no AgenciesProvider; brand from the selected company.
 * Prefer agencyName when the selected client is not itself an agency.
 */
export const getClientBrandingName = (
  client: {
    agencyName?: string | null;
    isAgency?: boolean | null;
    name?: string | null;
  } | null
): string | null => {
  if (!client) {
    return null;
  }

  if (client.isAgency === true) {
    return normalizeAgencyName(client.name);
  }

  return (
    normalizeAgencyName(client.agencyName) ?? normalizeAgencyName(client.name)
  );
};

export const getPrivateResourcesLabel = (
  agencyName: string | null | undefined
): string => {
  const name = normalizeAgencyName(agencyName);
  return name ? `Private ${name} Resources` : 'Private Resources';
};
